import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-premium">
      {/* Hero Section with BIG Side-by-Side Video */}
      <section className="hero-section">
        <div className="container hero-grid">
          
          {/* Left Side: Text */}
          <div className="hero-text">
            <span className="badge-glow">The Future of Patient Flow</span>
            <h1>Next-Gen Healthcare <br/> <span>Digitized with Smart QR</span></h1>
            <p>Eliminate queues. Seamlessly connect Patients, Doctors, Labs, and Pharmacies with a single scan.</p>
            <div className="hero-actions">
              <Link to="/contact" className="btn-primary">Request Private Demo</Link>
            </div>
          </div>

          {/* Right Side: PREMIUM VIDEO PLAYER */}
          <div className="hero-video-container">
            <div className="video-monitor-frame hero-version">
              <video 
                className="cinematic-video" 
                controls 
                width="100%"
                poster="/images/video-poster.jpg"
                preload="metadata"
              >
                {/* #t=0.1 skips the initial black frame if supported */}
                <source src="/videos/demo.mp4#t=0.1" type="video/mp4" />
                <source src="/videos/demo.mov#t=0.1" type="video/quicktime" />
                Your browser does not support the video tag.
              </video>
              <div className="nano-overlay"></div>
            </div>
          </div>

        </div>
      </section>

      {/* Process Section - FIXED STRUCTURE */}
      <section className="process-section">
        <div className="container">
          <h2 className="section-title">One QR. A Complete Ecosystem.</h2>
          <div className="process-grid">
            <div className="process-card">
              <div className="process-number">01</div>
              <h3>Instant Check-in</h3>
              <p>Patients scan to register. No paper forms, no waiting.</p>
            </div>
            <div className="process-card highlight">
              <div className="process-number">02</div>
              <h3>Live Consultation</h3>
              <p>Doctors access history instantly on their iPad or Desktop.</p>
            </div>
            <div className="process-card">
              <div className="process-number">03</div>
              <h3>Smart Pharmacy</h3>
              <p>Prescriptions flow digitally. Medicines are ready before you arrive.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;